// extracted by mini-css-extract-plugin
export default {"mobileUserInfoTable":"MobileRecordedUserEntries_mobileUserInfoTable__fi4lr"};